import { useState, useCallback } from "react";
import { loginRequest } from "../api/loginRequest";
import { tokenStorage } from "shared/api/tokenStorage";
import { userStore, syncUserFromToken } from "entities/user";
import { getErrorMessage } from "shared/api/getErrorMessage";
import { useUserStore } from "entities/user/hooks/useUserStore";

export function useLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { reset: resetUser } = useUserStore();

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const login = useCallback(async ({ login, password }) => {
    setLoading(true);
    setError(null);

    try {
      const data = await loginRequest({ login, password });

      if (!data?.accessToken || !data?.refreshToken || !data?.tokenType) {
        throw {
          type: "response",
          status: 500,
          message: "Сервер вернул неполные данные авторизации",
          data,
        };
      }

      tokenStorage.setTokens(data);
      syncUserFromToken();

      return data;
    } catch (e) {
      const status = e?.status;
      setError({
        status,
        message: getErrorMessage(e),
      });
      resetUser();
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { login, loading, error, clearError };
}
